import {
  Navigate,
} from 'react-router-dom';

import { uiRoutes } from '@consumer-frontend/nc-api';
import {
  applyEligibilityGuard,
  authenticatedGuard,
  coldStartGuard,
  loadReturningCustomerData,
  NcAddressPage,
  NcBasicInfoPage,
  NcBorrowingNeedsPage,
  NcConsentsPage,
  NcGenericErrorPage,
  NcIncomeDetailsPage,
  NcIncomeSourcePage,
  NcMaritalInformationPage,
  NcNotFoundErrorPage,
  NcPhoneNumberPage,
  NcSigninPage,
  NcUnableToContinuePage,
  NcVerifyContactInfoPage,
  NcVerifyEmailCodePage,
  NcVerifyEmailPage,
  NcVerifyIdentityRouting,
  NcVerifyIncomePage,
  NcVerifySigninPage,
  unAuthenticatedGuard,
} from '@consumer-frontend/nc-components';

import { HomePage } from './app/HomePage';
import {
  AuthenticatedLayout,
  RootLayout,
} from './app/layouts';

/* eslint-disable sort-keys */
export const routes = [
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <NcGenericErrorPage />,
    middleware: [
      loadReturningCustomerData,
      applyEligibilityGuard,
      coldStartGuard,
    ],
    children: [
      {
        path: uiRoutes.apply.authenticatedHome,
        element: <AuthenticatedLayout />,
        errorElement: <NcGenericErrorPage />,
        children: [
          {
            path: uiRoutes.apply.consents,
            element: <NcConsentsPage />,
          },
          {
            path: uiRoutes.apply.incomeDetails,
            element: <NcIncomeDetailsPage />,
          },
          {
            path: uiRoutes.apply.incomeSource,
            element: <NcIncomeSourcePage />,
          },
          {
            path: uiRoutes.apply.verifyIncome,
            element: <NcVerifyIncomePage />,
          },
          {
            path: uiRoutes.apply.verifyContactInfo,
            element: <NcVerifyContactInfoPage />,
          },
          {
            path: uiRoutes.apply.verifyMaritalInformation,
            element: <NcMaritalInformationPage />,
          },
        ],
        middleware: [authenticatedGuard],
      },
      {
        errorElement: <NcGenericErrorPage />,
        middleware: [unAuthenticatedGuard],
        children: [
          {
            path: uiRoutes.apply.address,
            element: <NcAddressPage />,
          },
          {
            path: uiRoutes.apply.basicInfo,
            element: <NcBasicInfoPage />,
          },
          {
            path: uiRoutes.apply.borrowingNeeds,
            element: <NcBorrowingNeedsPage />,
          },
          {
            path: uiRoutes.apply.maritalInformation,
            element: <NcMaritalInformationPage />,
          },
          {
            path: uiRoutes.apply.phoneNumber,
            element: <NcPhoneNumberPage />,
          },
          {
            path: uiRoutes.apply.signin,
            element: <NcSigninPage />,
          },
          {
            path: uiRoutes.apply.verifyEmail,
            element: <NcVerifyEmailPage />,
          },
          {
            path: uiRoutes.apply.verifyEmailCode,
            element: <NcVerifyEmailCodePage />,
          },
          {
            path: uiRoutes.apply.verifyIdentity,
            element: <NcVerifyIdentityRouting />,
          },
        ],
      },
      {
        index: true,
        path: '',
        element: <HomePage />,
      },
      {
        path: uiRoutes.apply.unableToContinue,
        element: <NcUnableToContinuePage />,
      },
      {
        path: uiRoutes.apply.verifySignin,
        element: <NcVerifySigninPage />,
      },

      // Fallback for unmatched routes
      {
        path: uiRoutes.apply.notFound,
        element: <NcNotFoundErrorPage />,
      },
      {
        path: '*',
        element: <Navigate to={uiRoutes.apply.notFound} />,
      },
    ],
  },
];
/* eslint-enable sort-keys */
